/* FullscreenIncidentChatModal.js with Bootstrap 5.3.3, overlay cleanup, react-bootstrap styling - 06-22-25 */
/* this is a copy of IncidentChatModal.js and should be deleted from the system since it is never used
*   was probaby a failed first attempt w/ josh crowd and never cleaned up so to keep system from breaking
*   with the new Bootstra 5 update,  I am leaving the code here for a while.. need to get back to it
*/
/* 6/23/25 3:22 to fix broken chat by grk */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modal';
import { fetchMessages, postChatMessage, updatePendingMessage, clearPendingMessage, clearMessages } from '../../actions/messages';
// import { putCloseChat } from '../../actions/reportSummaries';
import Messages from '../../views/Messages/Messages';
import './IncidentChatModal.css';

class IncidentChatModal extends Component {
  constructor(props) {
    super(props);
    this.addMessage = this.addMessage.bind(this);
    this.prepareFetch = this.prepareFetch.bind(this);
    this.startPoll = this.startPoll.bind(this);
    this.hide = this.hide.bind(this);
    this.closeChat = this.closeChat.bind(this);
    this.modalInstance = null; // xt this looks new, not sure why grk addedit
  }

  addMessage() {
    const { dispatch, messages, profile, incident, agencyId, reportSchemaId } = this.props;
    const message = {
      type: 'chat',
      display_name: profile.user_metadata?.name || profile.name,
      message: messages.pendingMessage,
      sender_id: profile.user_id,
      sent: Date.now(),
    };
    dispatch(postChatMessage(incident._id, agencyId, reportSchemaId, message));
    dispatch(clearPendingMessage());
  }

  // this hide() seems to call hideModal that is directly called in show photos and show map
  hide() {
    console.log('Hiding Chat Bootstrap modal');
    const modalElement = document.getElementById('chat-modal');
    if (modalElement && window.bootstrap && this.modalInstance) {
      try {
        this.modalInstance.hide();
        this.modalInstance.dispose();
        this.modalInstance = null;
      } catch (error) {
        console.error('Error hiding Chat modal:', error);
      }
    }
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    const backdrop = document.querySelector('.chat-modal-backdrop');
    if (backdrop) {
      console.log('Chat backdrop removed:', !document.querySelector('.chat-modal-backdrop'));
      backdrop.remove();
    }
    this.props.dispatch(hideModal());
  }

  prepareFetch() {
    const { dispatch, incident, agencyId, reportSchemaId } = this.props;
    console.log('Preparing fetch for messages - incident._id:', incident._id);
    dispatch(fetchMessages(incident._id, agencyId, reportSchemaId));
  }

  closeChat() {
    console.log('closeing chat modal');
    // const { dispatch, incident, agencyId, reportSchemaId } = this.props;
    // dispatch(putCloseChat(incident._id, agencyId, reportSchemaId));
    this.hide();
  }

  startPoll() {
    this.timeout = setTimeout(() => {
      this.prepareFetch();
    }, 10000);
  }

  // componentWillMount() {
  //   console.log('ChatModal willMount - visible:', this.props.visible);
  //   this.props.dispatch(clearMessages());
  //   this.prepareFetch();
  // }

  // 
  

  componentDidMount() {
    console.log('ChatModal mounted - props:', {
      visible: this.props.visible,
      bootstrap: !!window.bootstrap,
      incidentId: this.props.incident?._id,
    });
    if (!window.bootstrap) {
      console.error('Bootstrap not loaded');
    }
    this.prepareFetch();
    if (this.props.visible && window.bootstrap) {
      const modalElement = document.getElementById('chat-modal');
      if (modalElement && !this.modalInstance) {
        console.log('Initializing Chat Bootstrap modal');
        try {
          this.modalInstance = new window.bootstrap.Modal(modalElement, { backdrop: 'static', keyboard: false });
          this.modalInstance.show();
        } catch (error) {
          console.error('Bootstrap modal init error:', error);
        }
      }
    }
  }

  // preious code that wokred befoe grdk broke it by just chageng sytle names
  // componentDidUpdate(prevProps) {
  //   console.log('ChatModal updated - visible:', this.props.visible, 'prev visible:', prevProps.visible);
  //   clearTimeout(this.timeout);
  //   if (prevProps.messages?.isFetching && !this.props.messages?.isFetching) {
  //     this.startPoll();
  //   }
  //   if (this.props.visible && !prevProps.visible && window.bootstrap) {
  //     const modalElement = document.getElementById('chat-modal');
  //     console.log('Bootstrap modal element on update:', modalElement ? 'Found' : 'Not found');
  //     if (modalElement) {
  //       console.log('Showing Bootstrap modal on update');
  //       new window.bootstrap.Modal(modalElement, { backdrop: 'static', keyboard: false }).show();
  //     }
  //   }
  // }


  componentDidUpdate(prevProps) {
    console.log('ChatModal updated - props:', {
      visible: this.props.visible,
      prevVisible: prevProps.visible,
      isFetching: this.props.messages?.isFetching,
    });
    clearTimeout(this.timeout);
    if (prevProps.messages?.isFetching && !this.props.messages?.isFetching) {
      console.log('Chat fetch complete, starting poll');
      this.startPoll();
    }
    if (this.props.visible && !prevProps.visible && window.bootstrap) {
      const modalElement = document.getElementById('chat-modal');
      console.log('Bootstrap modal element on update:', modalElement ? 'Found' : 'Not found');
      if (modalElement && !this.modalInstance) {
        console.log('Showing Chat Bootstrap modal on update');
        try {
          this.modalInstance = new window.bootstrap.Modal(modalElement, { backdrop: 'static', keyboard: false });
          this.modalInstance.show();
        } catch (error) {
          console.error('Bootstrap modal init error:', error);
        }
      }
    }
  }
  componentWillUnmount() {
    this.hide();
    clearTimeout(this.timeout);
  }


  render() {
    const { incident, messages, pendingMessage, visible } = this.props;
    console.log('ChatModal render - visible:', visible, 'incident._id:', incident?._id);
    if (!visible || !incident?._id) {
      console.log('ChatModal render - returning null: visible:', visible, 'incident._id:', incident?._id);
      return null;
    }

    console.log('ChatModal render - Messages props:', {
      incidentId: incident._id,
      messageCount: messages.messages?.filter(msg => msg.type === 'chat')?.length,
      pendingMessage,
    });
    console.log('ChatModal render - DOM check:', document.getElementById('chat-modal') ? 'Modal in DOM' : 'Modal NOT in DOM');

    return (
       <div>
      {/* Backdrop */}
      <div className="chat-modal-backdrop fade show" />
      {/* Modal */}
      <div
        className={`chat-modal fade ${visible ? 'show d-block' : ''}`}
        id="chat-modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="chatModalLabel"
        aria-hidden={!visible}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="chat-modal-dialog modal-dialog-centered" role="document">
          <div className="chat-modal-content">
            <div className="chat-modal-header">
              <h5 className="chat-modal-title d-flex align-items-center" id="chatModalLabel">
                <i className="material-icons me-2">chat</i>
                <span>Chat - {incident.incident_number || 'INC-Unknown'} - {incident.title || 'Untitled'}</span>
              </h5>
              <button
                type="button"
                className="chat-modal-close-button"
                onClick={this.hide}
                aria-label="Close"
              >
                Close X
              </button>
            </div>
            <div className="chat-modal-body" id="chat-modal-body">
              <Messages
                closeTitle="End Chat"
                incident={incident}
                messages={messages.messages.filter(msg => msg.type === 'chat')}
                pendingMessage={pendingMessage}
                hide={this.hide}
                clearMessages={clearMessages}
                updatePendingMessage={updatePendingMessage}
                addMessage={this.addMessage}
                closeModal={this.closeChat}
              />
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const modalProps = state.modal?.modalProps || {};
  console.log('ChatModal mapStateToProps - state.modal:', state.modal);
  return {
    ...modalProps,
    visible: state.modal?.visible || false,
    messages: state.messages || {},
    profile: state.profile?.details || { user_id: '' },
  };
};

export default connect(mapStateToProps)(IncidentChatModal);